import { QR_TYPES } from "@/constant/qr_type.enum";
import { InitialVCardData } from "../../components/modules/vcard/data/vcard.repository";
import {
  AddButtonInitialData,
  BusinessInitalData,
} from "../../components/modules/businesspage/data/business.repository";
import { ImageInitialData } from "@/components/page-modules/builder/components/modules/images/data/images.repository";
import { EmailInitialData } from "../../components/modules/email/data/email.repository";
import { MenuInitialData } from "../../components/modules/menu/data/menu.repository";
import { PdfInitialData } from "../../components/modules/pdf/data/pdf.repository";
import { Mp3InitialData } from "../../components/modules/mp3/data/mp3.repository";
import { VideoInitialData } from "../../components/modules/video/data/video.repository";
import { CallInitialState } from "../../components/modules/call/data/call.repository";
import { CouponInitialData } from "../../components/modules/coupon/data/coupon.repository";
import { AppInitialData } from "../../components/modules/app/data/app.repository";
import { EventInitialData } from "../../components/modules/event/data/event.repository";
import { SocialMediaInitialData } from "../../components/modules/socialmedia/data/social-media.repository";
import { InitialFeedbackData } from "../../components/modules/feedback/data/feedback.repository";
import { FacebookInitialData } from "../../components/modules/facebook/data/facebook.repository";
import { WifiInitialData } from "../../components/modules/wifi/data/wifi.repository";
import { LocationInitialData } from "../../components/modules/location/data/location.repository";
import { BitcoinInitialData } from "../../components/modules/bitcoin/data/bitcoin.repository";
import { InitialTextData } from "../../components/modules/text/data/text.repository";
import { InitialRatingData } from "../../components/modules/rating/data/rating.repository";
import { InitialSmsData } from "../../components/modules/sms/data/sms.repository";
import { InitialUrlData } from "../../components/modules/url/data/url.repository";
import { InitialLinkedinData } from "../../components/modules/linkedin/data/linkedin.repository";

export type QRData = Record<QR_TYPES, Record<string, any>>;

export const initialState: QRData = {
  [QR_TYPES.APP]: AppInitialData,
  [QR_TYPES.BITCOIN]: BitcoinInitialData,
  [QR_TYPES.BUSINESSPAGE]: {
    ...BusinessInitalData,
    addButton: AddButtonInitialData,
  },
  [QR_TYPES.CALL]: CallInitialState,
  [QR_TYPES.COUPON]: CouponInitialData,
  [QR_TYPES.EMAIL]: EmailInitialData,
  [QR_TYPES.EVENT]: EventInitialData,
  [QR_TYPES.FACEBOOK]: FacebookInitialData,
  [QR_TYPES.FEEDBACK]: InitialFeedbackData,
  [QR_TYPES.IMAGES]: ImageInitialData,
  [QR_TYPES.LINKEDIN]: InitialLinkedinData,
  [QR_TYPES.LOCATION]: LocationInitialData,
  [QR_TYPES.MENU]: MenuInitialData,
  [QR_TYPES.MP3]: Mp3InitialData,
  [QR_TYPES.PDF]: PdfInitialData,
  [QR_TYPES.RATING]: InitialRatingData,
  [QR_TYPES.SMS]: InitialSmsData,
  [QR_TYPES.SOCIALMEDIA]: SocialMediaInitialData,
  [QR_TYPES.TEXT]: InitialTextData,
  [QR_TYPES.URL]: InitialUrlData,
  [QR_TYPES.VCARD]: InitialVCardData,
  [QR_TYPES.VIDEO]: VideoInitialData,
  [QR_TYPES.WIFI]: WifiInitialData,
};
